module.exports = __webpack_public_path__ + "img/logo.0822efa5.png";